import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dialog as MUIDailog } from '@material-ui/core';
import withSizes from 'react-sizes';

import { dialogSelectors } from '@store/ducks';
import PanConfirmation from '@components/PanDetails/Confirmation';
import Sheet from 'deltoid/core/Blocks/Sheet';

const Dialog = ({
  type,
  open,
  onClose: onCloseProp,
  isMobile,
}) => {

  const getChild = type => {
    let child = '';
    switch(type) {
      case 'pan-confirmation': {
        child = <PanConfirmation/>;
        break;
      }
      default: {
        child = null;
      }
    }
    return child;
  }

  const handleClose = () => onCloseProp();

  return (
    <>
      {
        getChild(type) ? (
          !isMobile ? (
            <MUIDailog
            open={open}
            onClose={handleClose}
            maxWidth="xs"
            fullWidth={false}
            >
            {getChild(type)}
            </MUIDailog>
          ) : (
            <Sheet className='bg-white sheet-b-radius' open={open} bottom onOverlayClick={handleClose}>
              {getChild(type)}
            </Sheet>
          )
        ) : <></>
      }
    </>
  )
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});
const ResponsiveDialog = withSizes(mapSizesToProps)(Dialog);

const mapStateToProps = (state) => {
  return {
    open: dialogSelectors.open(state),
    type: dialogSelectors.type(state),
  };
};

export default connect(mapStateToProps)(ResponsiveDialog);
